import React, { useEffect, useState } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { theme } from '../components/common/theme'
import { fetchUserQuota } from '../store/subscriptionSlice'

function PaymentSuccess() {
  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState('Checking payment status...')
  const dispatch = useDispatch()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const sessionId = searchParams.get('session_id')
  const processId = searchParams.get('processId')

  useEffect(() => {
    if (sessionId) {
      // Payment confirmation is handled by webhook, just show success
      setStatus('Payment complete! Thank you.')
      
      // Refresh user quota after successful payment
      // Get user ID from auth state or localStorage
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user?.id) {
        dispatch(fetchUserQuota(user.id));
      }
      
      setLoading(false);
    } else {
      setStatus('No session ID found in the URL.')
      setLoading(false)
    }
  }, [sessionId, dispatch])

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Payment Success</h2>

      {loading ? (
        <p style={styles.message}>Processing your payment. Please wait...</p>
      ) : (
        <p style={styles.message}>{status}</p>
      )}

      {processId && (
        <p style={styles.processInfo}>
          <strong>Process ID:</strong> {processId}
        </p>
      )}

      {/* Example “Next Steps” or navigation link */}
      <div style={styles.nextSteps}>
        <Link to="/dashboard" style={styles.linkButton}>
          Go to Dashboard
        </Link>
      </div>
    </div>
  )
}

export default PaymentSuccess

const styles = {
  container: {
    backgroundColor: theme.colors.primaryBackground,
    color: theme.colors.textPrimary,
    padding: theme.spacing.lg,
    borderRadius: theme.borderRadius.md,
    maxWidth: '600px',
    margin: '4rem auto',
    textAlign: 'center',
    boxShadow: theme.shadows.medium,
  },
  header: {
    fontFamily: theme.fonts.primary,
    fontSize: theme.fontSizes.lg,
    marginBottom: theme.spacing.md,
    color: theme.colors.title,
  },
  message: {
    fontFamily: theme.fonts.secondary,
    fontSize: theme.fontSizes.md,
    marginBottom: theme.spacing.md,
  },
  processInfo: {
    fontFamily: theme.fonts.secondary,
    fontSize: theme.fontSizes.sm,
    color: theme.colors.textSecondary,
    marginBottom: theme.spacing.lg,
  },
  nextSteps: {
    marginTop: theme.spacing.lg,
  },
  linkButton: {
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    backgroundColor: theme.colors.secondary,
    color: theme.colors.white,
    textDecoration: 'none',
    borderRadius: theme.borderRadius.sm,
    transition: theme.transitions.button,
    fontFamily: theme.fonts.primary,
  },
}
